export default __webpack_public_path__ + "static/media/050_brake.av1.1309ef53.mp4";